import { render, staticRenderFns } from "./navxbcmimgList.vue?vue&type=template&id=7b03dd51"
import script from "./navxbcmimgList.vue?vue&type=script&lang=js"
export * from "./navxbcmimgList.vue?vue&type=script&lang=js"
import style0 from "./navxbcmimgList.vue?vue&type=style&index=0&id=7b03dd51&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports